import { Directive, ElementRef, AfterViewInit, OnDestroy, Inject } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { AssetUrlInterceptor } from "../interceptors/asset-url.interceptor";

/**
 * Diretiva global que corrige caminhos de imagens com base no baseHref atual.
 * Aplicar apenas no app.component.html
 */
@Directive({
  selector: "[appFixImagePaths]",
  standalone: true,
})
export class AssetUrlDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver | null = null;

  constructor(
    private el: ElementRef,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private assetUrlInterceptor: AssetUrlInterceptor,
  ) {}

  ngAfterViewInit(): void {
    // Corrige imagens existentes
    this.fixExistingImages();

    // Configura um observador para corrigir imagens adicionadas dinamicamente
    this.setupObserver();
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  private fixExistingImages(): void {
    const images = this.el.nativeElement.querySelectorAll("img");
    images.forEach((img) => this.fixImagePath(img));
  }

  private fixImagePath(imgElement: HTMLImageElement): void {
    if (imgElement.src && imgElement.src.includes("/images/")) {
      const originalSrc = imgElement.getAttribute("src");
      if (originalSrc) {
        imgElement.src = this.assetUrlInterceptor.adjustAssetUrl(originalSrc);
      }
    }
  }

  private setupObserver(): void {
    // Observa mudanças no DOM para encontrar novas imagens adicionadas
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof HTMLImageElement) {
              this.fixImagePath(node);
            } else if (node instanceof Element) {
              const images = node.querySelectorAll("img");
              images.forEach((img) => this.fixImagePath(img));
            }
          });
        }
      });
    });

    // Inicia a observação do DOM
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
    });
  }
}
